var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettingIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.6,
  d: "m10 .834 7.917 4.583v9.167L10 19.167l-7.917-4.583V5.417zm0 1.926L3.75 6.378v7.245L10 17.241l6.25-3.618V6.378zm0 10.574a3.333 3.333 0 1 1 0-6.667 3.333 3.333 0 0 1 0 6.667m0-1.667a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"
})));
export { SvgSettingIcon as ReactComponent };
export default __webpack_public_path__ + "600a2ef8120c2610f4abb72c8ba7ae06.svg";